import { ActionTree, MutationTree, GetterTree } from "vuex";
import { CommonState, RootState, messagesType } from "@/store/types";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const MessagesRepository = RepositoryFactory.get("messages");

// initial state
const state: any = {
	messages: [],
};

// actions
const actions: ActionTree<CommonState, RootState> = {
	async fetchMessage({ commit }, params: any) {
		const resultFetchMessage = await MessagesRepository.get();
		const descMessages = resultFetchMessage.data.documents.sort(function (a: any, b: any) {
			if (a.updateTime < b.updateTime) {
				return -1;
			} else {
				return 1;
			}
		});
		commit("fetchMessage", descMessages);
	},
	async setMessage({ commit }, params) {
		const postParams = {
			fields: {
				text: {
					stringValue: params.inputText,
				},
				user: {
					stringValue: params.nickName,
				}
			}
		}
		console.log(postParams);
		await MessagesRepository.createPost(postParams);
		const resultFetchMessage = await MessagesRepository.get();
		const descMessages = resultFetchMessage.data.documents.sort(function (a: any, b: any) {
			if (a.updateTime < b.updateTime) {
				return -1;
			} else {
				return 1;
			}
		});
		commit("fetchMessage", descMessages);
	},
};

// getters
const getters: GetterTree<CommonState, RootState> = {
	messages: (state: CommonState) => state.messages,
};

// mutations
const mutations: MutationTree<CommonState> = {
	fetchMessage(state: CommonState, payload: messagesType[]) {
		state.messages = payload;
	},
};

export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations,
};
